interface IBranchData {
  has_app?: boolean;
}

export default function initBranchSdk(branchKey: string, identity: string) {
  return import('branch-sdk').then(module => {
    return new Promise((resolve, reject) => {
      const branch = module.default;
      branch.init(branchKey, (err: any, data: IBranchData | undefined) => {
        if (!err) {
          branch.setIdentity(identity);
          resolve({
            branch_has_app: data && data.has_app === true,
          });
        }
        reject();
      });
    });
  });
}
